import type { BulkTenderItemResult } from "../schemas/bulk-tender-schema.ts";

const escapeCsvValue = (value: string | number): string =>
	`"${String(value).replaceAll('"', '""')}"`;

export const exportBulkTenderResults = (
	results: readonly BulkTenderItemResult[],
): void => {
	const rows = [
		["Quote ID", "Status", "PO", "Reason", "Reason Code"],
		...results.map((itemResult) =>
			itemResult.status === "tendered"
				? [itemResult.quoteId, "Tendered", itemResult.poNumber, "", ""]
				: [
						itemResult.quoteId,
						"Failed",
						"",
						itemResult.reason,
						itemResult.reasonCode,
					],
		),
	];
	const csv = rows
		.map((row) => row.map((value) => escapeCsvValue(value)).join(","))
		.join("\r\n");
	const blob = new Blob([csv], { type: "text/csv;charset=utf-8" });
	const url = globalThis.URL.createObjectURL(blob);
	const link = globalThis.document.createElement("a");

	link.href = url;
	link.download = "bulk-tender-results.csv";
	globalThis.document.body.append(link);
	link.click();
	link.remove();
	globalThis.URL.revokeObjectURL(url);
};
